import * as React from 'react';
import Table from 'react-bootstrap/Table';
import { NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Row from 'react-bootstrap/Row';
import slugify from 'slugify';
import Col from 'react-bootstrap/Col';
import { postRequest } from '../../lib/api';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import BreadcrumbsWrapper from '../../components/breadcrumbs';

export default function View() {
    const [products, setProducts] = useState([]);
    const [partnerName, setPartnerName] = useState('');
    const {id} = useParams();

    useEffect(() => {
        fetchPartnerDetails();
    }, []);

    const fetchPartnerDetails = async () => {
        try {
            const response = await postRequest(`private/getPartner/${id}`);
            if (response.status === 200 && response.data) {
                setPartnerName(response.data.name || '');
                // Set only the products that were selected for this partner
                if (response.data.products && Array.isArray(response.data.products)) {
                    setProducts(response.data.products);
                }
            }
        } catch (error) {
            console.error('Failed to fetch partner details:', error);
        }
    };

    return (
        <>
         <BreadcrumbsWrapper
                     items={[
                      { label: 'Dashboard', path: '/dashboard' },
                      { label: 'Partner Rate Cards', path: '/partner-rate-cards' },
                      { label: 'View Partner Products', path: '' },
                        ]}
                         />
                  <br></br>
            <div className='page-header pb-3'>
                <h1 className='mt-0 mb-0'>{partnerName}</h1>
            </div>

            <div className='page-top-formview mb-3'>
                <Row>
                    <Col sm={12}>
                        <div className='customer-tab-view'>
                            <Table responsive bordered>
                                <thead>
                                    <tr>
                                        <th colSpan={2} className='bg-grey' style={{ verticalAlign: "middle" }}>
                                            Products Offered
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {products.length > 0 ? (
                                        products.map((product, index) => {
                                            return (
                                                <tr key={product._id || index}>
                                                    <td>
                                                        &nbsp; {product.title}
                                                    </td>
                                                    <td>
                                                      <Tooltip title="Manage Rate Card">
    <Link
        to={`/partner-rate-cards/manage/${id}/${slugify(product.title, { lower: true, strict: true })}?product_id=${product._id}&partner_id=${id}`}
        className="red-link-text"
        state={{
            product_id: product._id,
            partner_id: id
        }}
    >
        <span className="red-link-text">Manage</span>
    </Link>
</Tooltip>
                                                        &nbsp;&nbsp; | &nbsp;&nbsp;
                                                        <Tooltip title="View Leads">
                                                            <NavLink to="/#" className="red-link-text">
                                                                Search Leads
                                                            </NavLink>
                                                        </Tooltip>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={2}>No products found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            </div>

        </>
    );
}
